<template>
  <div>
    <div class="tw-flex tw-gap-2 tw-mb-4">
      <div class="tw-flex tw-flex-col tw-flex-1 tw-justify-between tw-border tw-border-gray dark:tw-border-dm-gray tw-overflow-hidden tw-rounded-3xl tw-p-3">
        <span class="tw-text-xl">
          {{ $dayjsFormatMetricDuration( permitIssueResponseTime.delta_avg, $t) }}
        </span>
        <span class="tw-text-gray-dark">
          {{ $t('dashboard.messaging_metrics.average_response_time') }}
        </span>
      </div>
      <div class="tw-flex tw-flex-col tw-flex-1 tw-justify-between tw-border tw-border-gray dark:tw-border-dm-gray tw-overflow-hidden tw-rounded-3xl tw-p-3">
        <span class="tw-text-xl">
          {{ $dayjsFormatMetricDuration(permitIssueResponseTime.delta_median, $t) }}
        </span>
        <span class="tw-text-gray-dark">
          {{ $t('dashboard.messaging_metrics.median_response_time') }}
        </span>
      </div>
      <div class="tw-flex tw-flex-col tw-flex-1 tw-justify-between tw-border tw-border-gray dark:tw-border-dm-gray tw-overflow-hidden tw-rounded-3xl tw-p-3">
        <span class="tw-text-xl">
          {{ $dayjsFormatMetricDuration(permitIssueResponseTime.delta_pct20, $t) }}
        </span>
        <span class="tw-text-gray-dark">
          {{ $t('dashboard.messaging_metrics.20_percentile_response_time') }}
        </span>
      </div>
    </div>

    <MetricFilters
      class="tw-mb-3"
      filters-state-relative-path="permitIssueMetricsFilters"
    />
    <AdministrationTableHeader
      store-path="v2/admin/dashboard"
      filters-state-relative-path="permitIssueMetricsFilters"
      filters-mutation-relative-path="sortPermitIssueMetricsByUser"
      :columns="columns"
      :need-to-translate-column-title="false"
    />
    <div class="tw-border tw-border-gray dark:tw-border-dm-gray tw-overflow-hidden tw-rounded-3xl">
      <template
        v-for="(userMetric, index) in metricsByUser"
        :key="userMetric.actor_id"
      >
        <div
          v-if="index > 0"
          class="tw-w-full tw-h-px tw-bg-gray dark:tw-bg-dm-gray"
        />
        <div
          class="tw-flex tw-items-center tw-py-1.5 tw-px-3 tw-gap-6 hover:tw-bg-light dark:hover:tw-bg-dm-light"
        >
          <div
            class="tw-flex tw-items-center tw-leading-5 tw-tracking-normal"
            :style="`width: ${columns[0].width}`"
          >
            {{ userMetric.actor_fullname }}
          </div>

          <div :style="`width: ${columns[1].width}`">
            {{ $dayjsFormatMetricDuration(userMetric.delta_avg, $t) }}
          </div>

          <div :style="`width: ${columns[2].width}`">
            {{ $dayjsFormatMetricDuration(userMetric.delta_median, $t) }}
          </div>

          <div :style="`width: ${columns[3].width}`">
            {{ $dayjsFormatMetricDuration(userMetric.delta_pct20, $t) }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import AdministrationTableHeader from '@/components/Administration/components/AdministrationTableHeader.vue';
import { mapGetters, mapState } from 'vuex';
import { permitIssueMetricsTableColumns } from '@/views/admin/dashboard/constants';
import { clientCompanyFilterMixin } from '@/mixins/clientCompanyFilterMixin';
import MetricFilters from '@/views/admin/dashboard/components/MetricFilters.vue';

export default {
  name: 'PermitIssueMetrics',
  components: { MetricFilters, AdministrationTableHeader },
  mixins: [clientCompanyFilterMixin],
  computed: {
    ...mapState({
      permitIssueResponseTime: (state) => state.v2.admin.dashboard.permitIssueResponseTime,
      metricsByUser: (state) => state.v2.admin.dashboard.permitIssueMetricsByUser,
    }),
    ...mapGetters({
      clientCompanies: 'v2/admin/cms/clients/companies/selectOptions',
    }),
    columns() {
      return permitIssueMetricsTableColumns(this.$t);
    },
  },
};
</script>
